export default __webpack_public_path__ + "pencil.asset.249fb4c7470984ec328cd5c205df6fe0.svg";